import React from 'react';

export default function Tank15Icon({
  width = 64,
  height = 92,
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 84.715 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="66.0771" x2="78.1633" y2="66.0771">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M78.163,105.949V19.654H0v86.295c0,0,2.357,6.551,39.082,6.551c1.017,0,3.05,0,4.066,0   C73.233,112.5,78.163,105.949,78.163,105.949z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="14.6836" x2="78.1633" y2="14.6836">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M39.082,6.551C3.94,6.551,0,19.654,0,19.654s9.52,3.163,39.082,3.163   c34.438,0,39.082-3.163,39.082-3.163S76.582,6.551,39.082,6.551z" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" strokeMiterlimit="10" d="M0,19.654c0,0,9.52,3.162,39.082,3.162   c34.438,0,39.081-3.162,39.081-3.162" />
</g>
<g id="Group_TBD">
	<path fill="#4B4B4B" d="M78.163,107.53h6.551v-1.581h-4.97V6.551L78.163,4.97H42.471l-1.808,1.582h-4.744v1.581h6.552l1.581-1.581   h32.53l1.581,1.581V107.53z" />
	<path fill="#7E7E7E" d="M44.052,6.551l-1.581,1.581h-6.552V4.97L40.663,0h39.081l4.97,4.97v100.979h-6.551V8.132l-1.581-1.581   H44.052z" />
	<path fill="#4B4B4B" d="M78.163,107.53h6.551v-1.581h-4.97V6.551L78.163,4.97H42.471l-1.808,1.582h-4.744v1.581h6.552l1.581-1.581   h32.53l1.581,1.581V107.53z" />
</g>
    
      </g>
      <rect x="0" y="0" width="84.715" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
